module.exports = __webpack_public_path__ + "img/jie-qu-guang-gao.9ec80414.jpg";